import { IValidationRule } from "@/types"

const tenantWarehouseValidationRules: { [s: string]: IValidationRule } = {
    description: {
        required: true,
    },
    tenantEmployee: {
        required: true,
    },
    location: {
        required: true,
    },
    geofenceRadius: {
        required: true,
        type: "decimal",
        min: 10,
        max: 10000,
        nonZero: true
    },
    addressStreet: {
        required: true,
    },
    addressZip: {
        required: true,
    },
    addressCity: {
        required: true,
    },
    addressCountryName: {
        required: true,
    },
}

export default tenantWarehouseValidationRules
